import { render, staticRenderFns } from "./category-med.vue?vue&type=template&id=ff7889b8&scoped=true"
import script from "./category-med.vue?vue&type=script&lang=js"
export * from "./category-med.vue?vue&type=script&lang=js"
import style0 from "./category-med.vue?vue&type=style&index=0&id=ff7889b8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff7889b8",
  null
  
)

export default component.exports